import React from 'react';
import CategoryPage from '../components/category/CategoryPage';

function KhelkudPage({ onOpen }) {
  return <CategoryPage onOpen={onOpen} title="खेलकुद" catSlug="sports" color="#1F7A4D" />;
}

export default KhelkudPage;